import service from '@/api/newsletter/sourceAuthType';
import {handleError} from '@/state/generators/helpers';
import {alert, loading} from "../../generators/helpers";

export const state = {
    item: {},
    service: service('newsletters/sourceAuthTypes')
}

export const getters = {}

export const mutations = {}

export const actions = {
    check: function ({commit, state}, id) {
        loading(commit)

        return state.service.check(id).then(response => {
            alert(commit, this.$t('base.okay'));
            loading(commit, false);
            return response;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
